import { downgradeComponent } from '@angular/upgrade/static';

//import { PipelineComponent } from './pipeline';
import { LegendComponent } from './legend-ang7/legend';
import { ProjectMenuComponent } from './projectMenu/projectMenu';
// import { EnvironmentTypeComponent } from './environments/environment-type';
// import { EnvironmentComponent } from './environments/environment/environment';
import { ActivitiesComponent } from './activities/activities.component';
import { PiplineComponent } from './pipleline-ang7'
// import {ProcessesHoverViewComponent} from './processesHoverView-ang7/processesHoverView'
// import { ProcessesHoverViewComponent }  from './processesHoverView/processesHoverView';

export default angular.module('pipeline', [])
  //  .component('pipeline', PipelineComponent)
    // .component('environmentType', EnvironmentTypeComponent)
    // .component('environment', EnvironmentComponent)
    // .component('legend', LegendComponent)PiplineComponent
    .component('projectMenu', ProjectMenuComponent)
    .directive('pipeline', downgradeComponent({ component: PiplineComponent }))
    .directive('legend', downgradeComponent({ component: LegendComponent }))
    .directive('activities', downgradeComponent({ component: ActivitiesComponent }))
    // .directive('processesHoverView', downgradeComponent({ component: ProcessesHoverViewComponent }))
    //  .component('processesHoverView', ProcessesHoverViewComponent)
    .constant('JobsNormalInterval', window.__env.config.jobsNormalInterval)
    .constant('JobsSpeedInterval', window.__env.config.jobsSpeedInterval)
    .filter('unique', function() {
        return function(collection, keyname1,keyname2) {
          var output = [], keys = [];
          angular.forEach(collection, function(item) {
              // we check to see whether our object exists
              var key = item[keyname1,keyname2];

              // if it's not already part of our keys array
              if (keys.indexOf(key) === -1) {
                  // add it to our keys array
                  keys.push(key);
                  // push this item to our final output array
                  output.push(item);
              }
          });
          return output;
      };
    });



// WEBPACK FOOTER //
// ./src/app/authorized/project/pipeline/module.js